import type { AccountDailyRow } from '../lib/statsHistoryChart';
import { getAuthHeaders } from './auth-headers';
import { SUPABASE_FUNCTIONS_URL } from './config';

export type PublicationDailyRow = {
  media_id: string;
  account_id: string;
  stat_date: string;
  media_type: string | null;
  permalink: string | null;
  thumbnail_url: string | null;
  published_at: string | null;
  views: number | null;
  reach: number | null;
  likes: number | null;
  comments: number | null;
  shares: number | null;
  saved: number | null;
  caption: string | null;
  archived_thumb: string | null;
};

export async function fetchStatsAccounts(): Promise<{ accounts: { account_id: string; username: string }[]; minDate: string | null }> {
  const headers = await getAuthHeaders();
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/stats-history?mode=accounts`, { headers });
  if (!res.ok) throw new Error(`stats-history accounts: HTTP ${res.status}`);
  const json = await res.json();
  return { accounts: json.accounts ?? [], minDate: json.min_date ?? null };
}

export type AudienceRow = {
  account_id: string;
  stat_date: string;
  by_country: Record<string, number> | null;
  by_city: Record<string, number> | null;
  by_age: Record<string, number> | null;
  by_gender: Record<string, number> | null;
};

export async function fetchStatsHistory(
  accountId: string,
  from: string,
  to: string,
): Promise<{ daily: AccountDailyRow[]; publications: PublicationDailyRow[]; audience: AudienceRow | null }> {
  const headers = await getAuthHeaders();
  const qs = new URLSearchParams({ accountId, from, to });
  const res = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/stats-history?${qs}`, { headers });
  if (!res.ok) throw new Error(`stats-history: HTTP ${res.status}`);
  return res.json();
}
